import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import axios from 'helpers/axios';
import { SUBSCRIPTIONS } from 'constants/apis';

export default () => {
  const createSubscription = useCallback(
    async ({ stripeToken, name, email, price, utmSource, discount }) => {
      if (!stripeToken) {
        throw new Error('Bad Implementation');
      }

      const body = {
        name,
        email,
        tokenId: stripeToken.id,
      };

      const options = {
        params: {
          price: price.id,
          ...(discount.isCoupon ? { coupon: discount.id } : { promoCodeId: discount.id }),
          ...(utmSource && { utmSource }),
        },
      };

      try {
        await axios.post(SUBSCRIPTIONS, body, options);

        return { email };
      } catch (err) {
        if (err.response) {
          throw new Error(err.response.data.message);
        }

        throw err;
      }
    },
    []
  );

  return useMutation(createSubscription);
};
